import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import FormInput from '@src/mobile/layout/Component/FormInput';
import FormTextarea from '@src/mobile/layout/Component/FormTextarea';
import UploadVideo from '../Media/UploadVideo';

const Needlessly = ({
    formData,
    setFormDataHandle,
    warningTextList,
    updateSuccess
}) => {
    const [isUnfold, setUnfold] = useState(false);

    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    const unflodHandle = () => {
        setUnfold(!isUnfold);
    };

    return (
        <div className={styles.needlessly}>
            <div className={styles.needlesslyHead}>
                <div className={styles.needlesslyTitle}>选填信息</div>
                <div className={`${styles.needlesslyChange} ${isUnfold ? styles.active : ''}`} onClick={unflodHandle}>
                    <img className={styles.needlesslyPic1} src="https://x0.ifengimg.com/feprod/c/2024_9_6/17_27_37/86E3DF5D8CCF9974E82AB32E7023D51221C9A7E6_size6_w204_h60.png" />
                    <img className={styles.needlesslyPic2} src="https://x0.ifengimg.com/feprod/c/2024_9_6/17_27_37/3DB90441D54DE7773524F0DECEC9FB51C4A97DD9_size6_w204_h60.png" />
                </div>
            </div>
            <div className={styles.needlesslyInfo}>
                更丰富的自我介绍，能让我们更快速地了解你，以及快速地决定是否联繫你。
            </div>
            <div style={{ display: isUnfold ? 'block' : 'none' }} className={styles.formNeedlesslyList}>
                <div className={styles.formListBox}>
                    <FormTitle name="video_production" title="视频作品" warningText={warningTextList['video_production']} />
                    <div className={styles.picInfo}>选填资料可于必填资料提交之后再填写<br />请上传本人出镜、不使用美颜、不使用滤镜、不配乐、带环境、有主题、动态为主的视频，3分钟内<br />视频仅支持mp4、mov、quicktime格式</div>
                    <UploadVideo name="video_production" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="nationality" title="国籍" warningText={warningTextList['nationality']} />
                    <FormInput name="nationality" formData={formData} placeholder="" changeInputHandle={changeInputHandle} />
                    <FormTitle title="擅长语种" name="language" warningText={warningTextList['language']} />
                    <FormInput name="language" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        title="在读/毕业院校"
                        name="current_college"
                        warningText={warningTextList['current_college']}
                    />
                    <div className={styles.picInfo}>所在院校/专业（若有）/其他情况请如实填写</div>
                    <FormInput name="current_college" placeholder="XX大学XX学院" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        title="介绍一下自己"
                        name="self_introduction"
                        warningText={warningTextList['self_introduction']}
                    />
                    <FormTextarea
                        limitWord={1000}
                        formData={formData}
                        placeholder="性格特点、参与活动经历、获奖情况及特长等"
                        name="self_introduction"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormTitle
                        title="还能在哪些平台了解你"
                        name="other_platforms"
                        warningText={warningTextList['other_platforms']}
                    />
                    <FormTextarea
                        limitWord={300}
                        formData={formData}
                        placeholder="请列举社交平台名称及个人账号名等信息"
                        name="other_platforms"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                </div>
            </div>
        </div>
    );
};

Needlessly.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateSuccess: PropTypes.bool,
};

export default errorBoundary(Needlessly);
